import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { UPLOAD_STATUS } from "./DocumentUpload";

function AddDocument({ documents, dispatchUpdateAction }) {
  const { t } = useTranslation();

  const addDocument = useCallback(() => {
    documents.push({
      uploadStatus: UPLOAD_STATUS.NOT_STARTED,
      uploadError: null,
      uploadProgress: 0,
      label: "", // Sets value of input field hence empty string is used
      link: null,
      file: null,
      href: null,
      required: false,
    });
    dispatchUpdateAction();
  }, [dispatchUpdateAction, documents]);

  return (
    <>
      <FontAwesomeIcon
        style={{ display: "inline-block" }}
        icon={faPlus}
        className="has-text-grey is-clickable"
        onClick={addDocument}
      />
      <span style={{ display: "inline-block" }} className="ml-2">
        {t("requests.submission.upload.addDocument")}
      </span>
    </>
  );
}

export default AddDocument;
